<template>
	<o-card class="temp-worker-add-membership-marketing-card">
		<div
			v-if="!setup.ui.onLayoutNavBottom"
			class="temp-worker-add-membership-marketing-card__background">
			<img
				src="@/assets/img/Map.png"
				alt="Image illustrant la recherche d'une agence d'emploi">
		</div>

		<div class="temp-worker-add-membership-marketing-card__content">
			<template v-if="!!setup.relatedAgencies.length">
				<h2 class="temp-worker-add-membership-marketing-card__title">
					Bonjour {{ setup.self.firstName }},<br>
				</h2>
				<p class="temp-worker-add-membership-marketing-card__subtitle">
					<strong>Vous êtes {{ setup.self.isMale ? 'relié' : 'reliée' }} à {{ 'agence'.pluralize(setup.relatedAgencies.length) }}.</strong><br>
				</p>
				<o-section actions="left">
					<o-button
						color="brand"
						@click="$router.push({ name: 'UserProfileCompanies' })">
						Voir mes agences
					</o-button>
				</o-section>
			</template>
			<template v-else>
				<h2 class="temp-worker-add-membership-marketing-card__title">
					Bonjour {{ setup.self.firstName }},<br>
					reliez-vous à une agence d'emploi
				</h2>
				<p class="temp-worker-add-membership-marketing-card__subtitle">
					Afin d'utiliser la plateforme dans les meilleurs conditions,
					nous vous conseillons fortement de vous lier à une agence d'emploi.
				</p>
				<o-section actions="left">
					<o-button
						color="brand"
						@click="setup.openTempWorkerAddMembershipModal()">
						Saisir le code de l'agence
					</o-button>
				</o-section>
			</template>
		</div>
	</o-card>
</template>

<script setup lang="ts">
import DashboardTempWorkerAddMembershipMarketingCardSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerAddMembershipMarketingCardSetupService';
const setup = new DashboardTempWorkerAddMembershipMarketingCardSetupService();
</script>


<style scoped lang="less">
@import '@/styles/variables';
.temp-worker-add-membership-marketing-card {
  position: relative;
  overflow: hidden;

  &__background {
    position: absolute;
    height: 100%;
    width: 100%;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    img {
      object-fit: cover;
    }

    &::after {
      content: "";
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      background: linear-gradient(
        to right,
        white,
        white 30%,
        transparent,
      );
      z-index: 2;
    }
  }

  &__content {
    position: relative;
    z-index: 4;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    padding: 20px;

    @media @desktop {
      padding: 40px 50px;
    }

  }

  &__title {
    font-size: 1.5rem;
    line-height: 2rem;
    color: var(--grey-darker);
  }

  &__subtitle {
    font-size: 1rem;
    color: var(--grey-dark);
    margin-bottom: 2rem;
    max-width: 50%;

    @media @layoutNavBottom {
      max-width: 100%;
    }
  }
}
</style>
